module.exports = __webpack_public_path__ + "img/logo.553d9bf9.png";